import * as React from 'react';
import { Text } from '@grandvisionhq/iris-ui';
import { useIntl } from '@grandvisionhq/state';

const FormattedLabelLink = ({ tabIndex , labelKey , className  })=>{
    const { getFormattedLabel , hasLabel  } = useIntl();
    const formattedLabelLink = React.useMemo(()=>{
        if (!hasLabel(labelKey)) {
            return null;
        }
        const formattedLabel = getFormattedLabel(labelKey, {
            parseLink: true,
            parseHTML: true,
            hideLabelKey: true
        });
        if (!/*#__PURE__*/ React.isValidElement(formattedLabel)) {
            return formattedLabel;
        }
        return /*#__PURE__*/ React.cloneElement(formattedLabel, {
            tabIndex
        });
    }, [
        getFormattedLabel,
        hasLabel,
        tabIndex,
        labelKey
    ]);
    return /*#__PURE__*/ React.createElement(Text, {
        component: "div",
        className: className
    }, formattedLabelLink);
};

export { FormattedLabelLink };
//# sourceMappingURL=FormattedLabelLink.js.map
